import { useState } from "react";

import ButtonLoader from "../ButtonLoader";

const PartnerCompanyForm = ({ company, isLoading, onSubmit }) => {
  const [name, setName] = useState(company?.name || '');
  const [email, setEmail] = useState(company?.email || '');

  const handleSubmit = e => {
    e.preventDefault();

    onSubmit({
      name,
      email
    });
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4 w-full"
    >
      <label className="flex flex-col gap-1 w-full">
        Name

        <input
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </label>

      <label className="flex flex-col gap-1 w-full">
        Email

        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </label>


      <button
        type="submit"
        className="ase-button-primary h-[48px] flex items-center justify-center"
      >
        {isLoading ? <ButtonLoader /> : 'Submit'}
      </button>
    </form>
  );
}

export default PartnerCompanyForm;
